module.exports = __webpack_public_path__ + "static/img/1.343581c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/1.jpg
// module id = B9JE
// module chunks = 1